import { render, staticRenderFns } from "./HubDetail.vue?vue&type=template&id=321f5b9e&"
import script from "./HubDetail.vue?vue&type=script&lang=js&"
export * from "./HubDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports